import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getFeatures as getFeaturesApi } from '../../api/featuresApi';
import { RootState } from '../store';

export interface FeaturesState {
  userCanAssumeRole?: boolean;
}

const initialState: FeaturesState = {};

export const loadFeatures = createAsyncThunk(
  'features/loadFeatures',
  async () => {
    try {
      return await getFeaturesApi();
    } catch {
      return {
        userCanAssumeRole: false,
      };
    }
  }
);

export const featuresSlice = createSlice({
  name: 'features',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadFeatures.fulfilled, (state, action) => {
      state.userCanAssumeRole = action.payload.userCanAssumeRole;
    });
  },
});

export const selectUserCanAssumeRole = (state: RootState) =>
  state.features.userCanAssumeRole;

export default featuresSlice.reducer;
